import React, { useEffect, useState } from "react";
import { makeStyles } from 'tss-react/mui';
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles()(theme => ({
    chips: {
        display: "flex",
        flexWrap: "wrap",
    },
    chip: {
        margin: 2,
    },
    selectContainer: {
        width: "100%",
        textAlign: "left",
    },
}));

const SelectStatusContact = ({ selectId, onChange }) => {
    const { classes } = useStyles();
    const [contactStatus, setContactStatus] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.post("/contact/status/list");
                setContactStatus(data.data);
            } catch (err) {
                toastError(err);
            }
        })();
    }, []);

    const handleChangeUser = e => {
        onChange(e.target.value);
    };

    return (
        <FormControl fullWidth margin="dense" size="small">
            <Select
                fullWidth
                displayEmpty
                variant="outlined"
                MenuProps={{
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                    },
                }}
                value={selectId ?? ""}
                onChange={handleChangeUser}
                renderValue={() => selectId ? contactStatus.find(item => item.id === selectId)?.name || 'Status' : 'Status'}

            >
                <MenuItem key='' value=''>
                    Todas los status
                </MenuItem>
                {contactStatus.length > 0 &&
                    contactStatus.map(status => (
                        <MenuItem key={status.id} value={status.id}>
                            {status.name}
                        </MenuItem>
                    ))

                }

            </Select>
        </FormControl>
    );
};





export default SelectStatusContact;
